export default {
  errorHandlingForm(context, axiosPromise) {
    let allErrorSpans = document.getElementsByClassName("md-error");
    for (let span of allErrorSpans) {
      span.innerHTML = "";
    }
    axiosPromise.catch(err => {
      if (err.response) {
        for (let key in err.response.data) {
          let errorMessage = err.response.data[key];
          if (key == "detail" || key == "error") {
            context.$toasted.error(errorMessage);
          } else if (key == "background_picture") {
            context.$toasted.error("Background Picture: " + errorMessage);
          } else if (key == "profile_picture") {
            context.$toasted.error("Profile Picture: " + errorMessage);
          } else {
            let element = document.getElementById(key + "-error");
            if (element) {
              element.innerHTML = errorMessage;
            }
          }
        }
      }
    });
  },

  isObjEmpty(obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  },

  deepCopyObject(obj) {
    return JSON.parse(JSON.stringify(obj));
  },

  addClass(htmlElement, classToBeAdded) {
    let arr = htmlElement.className.split(" ");
    if (arr.indexOf(classToBeAdded) == -1) {
      htmlElement.className += " " + classToBeAdded;
    }
  },

  removeClass(htmlElement, classToBeAdded) {
    let arr = htmlElement.className.split(" ");
    let currIndex = arr.indexOf(classToBeAdded);
    while (currIndex != -1) {
      arr.splice(currIndex, 1);
      currIndex = arr.indexOf(classToBeAdded);
    }
    htmlElement.className = "" + arr.join(" ");
  },
  convertIntoLink(links) {
    if (!Array.isArray(links)) {
      links = [links];
    }
    for (let link of links) {
      if (link.indexOf("http") > -1) {
        link = "http://" + link;
      }
    }
    return links;
  },
  getProfilePicture(profile) {
    if (!profile.profile_picture) {
      return "./img/faces/avatar.jpg";
    }
    return profile.profile_picture;
  },
  getBackgroundPicture(profile) {
    if (!profile.background_picture) {
      return "./img/bg-pricing.jpg";
    }
    return profile.background_picture;
  },

  getBlogArticlePicture(blog) {
    if (!blog.background_picture) {
      return "./img/blog-pic.jpg";
    }
    return blog.background_picture;
  }
};
